// Switch management mode is a UI convention stored in vendor_extras (no backend
// column): "cli" = Hub configures the switch over CLI (C.5); "web_ui" = Hub
// generates manual setup instructions. Default is "cli".

import type { ManagementMode } from "../../api/types/siteSwitch";

export function getManagementMode(
  vendorExtras: Record<string, unknown> | null | undefined,
): ManagementMode {
  return vendorExtras?.management_mode === "web_ui" ? "web_ui" : "cli";
}

/** Return a new vendor_extras with management_mode set (does not mutate input). */
export function withManagementMode(
  vendorExtras: Record<string, unknown> | null | undefined,
  mode: ManagementMode,
): Record<string, unknown> {
  return { ...(vendorExtras ?? {}), management_mode: mode };
}
